import { graphql, useStaticQuery } from 'gatsby';

const useAllWorkshopEvents = () => {
  const { allContentfulWorkshop } = useStaticQuery(graphql`
    query {
      allContentfulWorkshop(sort: { fields: [title], order: ASC }) {
        edges {
          node {
            ...Workshop
          }
        }
      }
    }
  `);

  return allContentfulWorkshop?.edges.map(x => x.node);
};

export default useAllWorkshopEvents;
